import {
  type BoundaryGroupId, type BoundaryTerritoryGroupId,
} from '~/store/boundaries/boundaryIdentifier.type';
import {
  type BoundaryGroupDemographic, type BoundaryGroupMatchings,
} from '~/store/boundaryGroups/boundaryGroups.repository';

export enum BoundaryGroupCodenames {
  UsStates = 'us-states',
  UsCounties = 'us-counties',
  UsZipCodes = 'us-zip-codes',
  UsZipCodesLowDetail = 'us-zip-codes-lower',
}

export type BoundaryGroupBase = Readonly<{
  allowEditing: boolean;
  clientId: number | null;
  id: number;
  loadZoomLevel: number;
  name: string;
  sort: number | null; //this indicates the order in which the boundary group is displayed in the selected boundary type dropdown
  userId: number | null;
  zoomLevels: number[];
  matchings: BoundaryGroupMatchings | null;
  readonly: boolean;
  allowOverlap: boolean;
  wms: {
    territoriesCount: number;
    geometryRemainingCalls: number | null;
    wmsTemporary: boolean;
  };
  mot: {
    territoriesCount: number;
    geometryRemainingCalls: number | null;
    motTemporary: boolean;
  };
  createdFrom?: {
    boundaryTerritoryGroupId?: BoundaryTerritoryGroupId;
    boundaryGroupIds: ReadonlyArray<BoundaryGroupId>;
  };
  editBoundaryZoomLevel?: number;
  visible: boolean;
  graphsGenerated: boolean;
  region: string | null;
  etag?: {
    timestamp: number;
    lastUpdatedUserName: string;
    lastUpdatedUserId: number;
  };
}>;

export type BoundaryGroup = BoundaryGroupBase & Readonly<{
  demographics: readonly BoundaryGroupDemographic[];
  codename?: string;
}>;

export type BoundaryGroupDetails = BoundaryGroupBase & Readonly<{
  usedOnMaps: number[];
}>;
